import { type FC, type PropsWithChildren } from "react";

export const EducationPageContainer: FC<PropsWithChildren> = ({ children }) => {
    return <div className="flex flex-col gap-6 w-full md:max-w-5xl md:mx-auto md:p-6">{children}</div>;
};
